// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"header-module--menu-icon--3M9qp","mobileNav":"header-module--mobile-nav--j1XXV"};